<template>
  <form class="form form-vertical">
    <div class="form-body">
      <div class="row">
        <div class="w-full mt-5 mb-5">
          <vs-row>
            <vs-col vs-w="12">

              <vx-input-group class="mb-5">          
                <vs-input
                  label="Nome do Cargo"
                  v-model="role.display_name"
                  class="w-full"
                  name="Nome do Cargo"
                  v-validate="'required'"
                  :disabled="true"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('Nome do Cargo')"
                >
                  {{ errors.first('Nome do Cargo') }}
                </span>
              </vx-input-group>
            </vs-col>
          </vs-row>

          <vs-row>
            <vs-checkbox 
              class="mb-5"
              v-model="allIsChecked"
            >
              Selecionar Todas as Permissões
            </vs-checkbox>
          </vs-row>

          <vs-row>
            <vs-col
              v-for="(category, index) in allPermissions"
              :key="`category-card${index}`"
              vs-w="6"
            >
              <vs-card style="width: 97%;">
                <div slot="header">
                  <h4>
                    <vs-checkbox 
                      class="mb-5"
                      :vs-value="category.name"
                      v-model="allOfCategoryChecked"
                    >
                      {{ category.name.replace(/\//ig, ' / ') }}
                    </vs-checkbox>
                  </h4>
                </div>

                <div>
                  <vs-checkbox 
                    v-for="permission in category.permission"
                    :key="`permission-checkbox${permission.id}`"
                    :vs-value="permission.id"
                    class="mt-2 mb-2"
                    v-model="selectedPermissions"
                    v-if="isVisible(permission.display_name)"
                  >
                    {{ permission.display_name }}
                  </vs-checkbox>
                </div>
              </vs-card>
            </vs-col>
          </vs-row>

          <vx-input-group>
            <vs-button class="mr-6" @click="savePermissions()">
              Salvar
            </vs-button>
          </vx-input-group>
        </div>
      </div>
    </div>
  </form>
</template>

<script>

  import VuePerfectScrollbar from 'vue-perfect-scrollbar';
  import VNavMenuGroup from '@/layouts/components/vertical-nav-menu/VerticalNavMenuGroup.vue';
  import VNavMenuItem from '@/layouts/components/vertical-nav-menu/VerticalNavMenuItem.vue';
  import permissionHttp from '../../http/requests/permission/index';
  import roleHttp from '../../http/requests/role/index';
  import { mapGetters } from 'vuex';

  export default {
    name: 'role-form',
    data() {
      return {
        role: {
          display_name: '',
          roleId: undefined
        },
        categories: [],
        allPermissions: [],
        selectedPermissions: [],
        isSaved: false,
        selectAll: false,
        selectAllCategory: {},
        allIsChecked: false,
        allOfCategoryChecked: []
      }
    },
    methods: {
      isVisible(name) {
        const names = [
          'Criação de Dashes',
          'Criação de Conexões',
          'Atualização de Conexões'
        ];

        if (!names.includes(name)) return true;
        return this.originBackoffice;
      },
      verify(){
        const permissions = localStorage.getItem('permissions');
        const twoFactor = localStorage.getItem('twoFactor')
        if(!permissions && !twoFactor){
            this.$router.push('/user-settings')
        }else if(!permissions && twoFactor){
            this.$router.push('/two-factor')
        }
      },
      async permissions(token) {
        await permissionHttp.fetchAllWithCategories(token)
        .then((res) =>{ 
          this.allPermissions = res.data;
        });
      },
      async roleById(token, roleId) {
        await roleHttp.fetchRoleById(token, roleId)
        .then((res) =>{ 
          this.selectedPermissions = res.data.permission.map(item => item.id);
          this.role.display_name = res.data.display_name;
        });
      },
      async savePermissions() {
        permissionHttp.updatePermission(this.token, this.role.roleId, this.selectedPermissions)
        .then(response => {
          this.$vs.notify({
            title: 'Sucesso!',
            text: 'Atualização de Permissões feita com sucesso!',
            color: 'success'
          })

          this.$store.dispatch('fetchPermissions', {
            email: this.email, 
            token: this.token 
          });
        })
        .catch(Exception => {
          this.$vs.notify({
            title: 'Erro!',
            text: 'A atualização de Permissões falhou!',
            color: 'danger'
          })
        })
      }
    },
    created() {
      this.permissions(this.token);
      this.role.roleId = this.$route.params.id;

      if (this.role.roleId) {
        this.roleById(this.token, this.role.roleId);
      }
    },
    components: {
      VuePerfectScrollbar,
      VNavMenuGroup,
      VNavMenuItem
    },
    computed: {
      ...mapGetters([
        'token',
        'users',
        'email'
      ]),
      originBackoffice() {
        return localStorage.getItem('originBackoffice') !== 'false';
      }
    },
    watch: {
      allIsChecked(newVal) {
        if (newVal) {
          this.allPermissions.map(item => {
            item.permission.map(permission => {
              this.selectedPermissions.push(permission.id)
            });
          });
        } else {
          this.selectedPermissions = [];
        }
      },
      allOfCategoryChecked(newVal, oldVal) {
        const diff = oldVal.filter(item => !newVal.includes(item));

        if (diff.length) {
          this.allPermissions.map(item => {
            if (diff.includes(item.name)) {
              item.permission.map(permission => {
                let itemIndex = this.selectedPermissions.findIndex(value => value === permission.id);
                this.selectedPermissions.splice(itemIndex, 1);
              });
            }
          })
        }

        if (newVal.length) {
          this.allPermissions.map(item => {
            if (newVal.includes(item.name)) {
              item.permission.map(permission => {
                if (!this.selectedPermissions.includes(permission.id)) {
                  this.selectedPermissions.push(permission.id)
                }
              });
            }
          });
        }
      }
    },
    mounted(){
      this.verify()
    }
  }
</script>

<style>
button.button-remove-bg {
  color: #0B8FFA !important;
}

.menu-text-perm {
  font-size: 15px !important;
}

.vs-button-filled {
  color: #fff !important;
}
</style>